import { render, staticRenderFns } from "./BaseAutotraderButton.vue?vue&type=template&id=3d0f4acc&scoped=true"
import script from "./BaseAutotraderButton.vue?vue&type=script&lang=js"
export * from "./BaseAutotraderButton.vue?vue&type=script&lang=js"
import style0 from "./BaseAutotraderButton.vue?vue&type=style&index=0&id=3d0f4acc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0f4acc",
  null
  
)

export default component.exports